import React, { useEffect } from 'react';

import { Platform, Text, View } from 'react-native';

import setAccessibilityFocusTo from 'services/accessibility/setAccessibilityFocusTo';

import usePrevious from 'utils/hooks/usePrevious';
import { isWeb } from 'utils/responsiveness';

type Params = {
    accessibleViewRef: React.RefObject<View | Text | null>;
    focused: boolean;
};

function useAccessibilityFocus({ accessibleViewRef, focused }: Params) {
    const prevFocused = usePrevious(focused);

    useEffect(() => {
        if ((Platform.OS === 'ios' || isWeb) && !prevFocused && focused) {
            setAccessibilityFocusTo(accessibleViewRef);
        }
    }, [focused]);
}

export default useAccessibilityFocus;
